import React from 'react';
import { Button, Dropdown, Menu, Space } from 'antd';
import { Icon, Tooltip } from 'pepsico-ds';
import { DownOutlined } from '@ant-design/icons';
import spendHQ from '../../assets/SpendHQ.svg'
import Forestreet from '../../assets/Forestreet.svg'
import Archlet from '../../assets/Archlet.svg'
import Veridion from '../../assets/Veridion.svg'
import Sustainability from '../../assets/Sustainability.svg'
import Powesteering from '../../assets/Powersteering.svg'
import SAPAriba from '../../assets/SAPAriba.svg'
import Selectica from '../../assets/Selectica.svg'
import Cirtuo from '../../assets/Cirtuo.svg'
import Smartcube from '../../assets/Smartcube.svg'
import Resilinc from '../../assets/Resilinc.svg'
import ResilincNew from '../../assets/ResilincNew.svg'
import ResilincWithText from '../../assets/ResilincWithText.svg'

import Compass from '../../assets/Pepsico_Symbol.svg'
import Pepsico from '../../assets/Pepsico_Symbol.svg'
import Cockpit from '../../assets/Cockpit.svg'
import Spendwise from '../../assets/Spendwise.svg'
import Fastmarkets from '../../assets/Fastmarkets.svg'
import Fieldglass from '../../assets/Fieldglass.svg'
import PepsicoLatestLogo from '../../assets/PepsicoUpdatedLogo.svg'
import PGCS_Landing_Card_Logo from '../../assets/PGCS_Landing_Card.svg'
import Icertis_Logo from '../../assets/IcertisIcon.svg'
import Terzo_logo from '../../assets/TerzoIcon.svg'
import CMA_Logo from '../../assets/CMA_Logo.svg'
import Sbacci_Logo from '../../assets/sbacci_logo.svg'
import woodmac_Logo from '../../assets/woodmac_logo.svg'
import SP_Global_Logo from '../../assets/S&P_Global.svg'
import Keelvar from '../../assets/Keelvar.svg'
import { getAppLinkAttributes } from '../../utils/fullstory-utils';
// import { logoMap } from '../../mocks/LogoMap';

const logoMap = {
  "Forestreet (F)": Forestreet,
  "Forestreet": Forestreet,
  "Spend HQ": spendHQ,
  "Cockpit - AMESA": Cockpit,
  "Cockpit - Global": Cockpit,
  "Cockpit - APAC": Cockpit, 
  "SmartCube": Smartcube,
  "Global SPM": PepsicoLatestLogo,
   "Cirtuo": Cirtuo,
   "Selectica": Selectica,
   "SAP Ariba (SSS)": SAPAriba,
   "SAP Ariba (Standalone)": SAPAriba,
   "Sustainability Action Center": Sustainability,
   "Power Steering": Powesteering,
  "Archlet": Archlet,
  "Veridion (V)": Veridion,
  "Veridion": Veridion,
  "Compass": PepsicoLatestLogo,
  "PR Dashboard": PepsicoLatestLogo,
  "SCM Platform": PepsicoLatestLogo,
  "In-house MI Team": PepsicoLatestLogo,
  "AMESA PBI": PepsicoLatestLogo,
  "CoMan Automation": PepsicoLatestLogo,
  "AMESA PBI App": PepsicoLatestLogo,
  "AMESA Contract Analytics": PepsicoLatestLogo,
  // "Resilinc": ResilincWithText
  // "Resilinc": ResilincNew
  "Resilinc": Resilinc,
  "myBUY": SAPAriba,
  "myRIS": PepsicoLatestLogo,
  "SAP Ariba CLM": SAPAriba,
  "Ariba CLM (LATAM & Europe)": SAPAriba,
  "Ariba CLM (NA)": SAPAriba,
  "Seed Allocator": PepsicoLatestLogo,
  "T-Contract": PepsicoLatestLogo,
  "FastMarkets (RISI)": Fastmarkets,
  "Spendwise": Spendwise,
  "Insights Hub - NA": PepsicoLatestLogo,
  "Insights Hub - LATAM": PepsicoLatestLogo,
  "Insights Hub - India": PepsicoLatestLogo,
  "Performance Scorecard": PepsicoLatestLogo,
  "Fieldglass": Fieldglass,
  "Chemical Market Analysis": PepsicoLatestLogo, // TO BE CHANGED ONCE RECEIVED,
  "PGCS Analytics": PGCS_Landing_Card_Logo,
  "Icertis": Icertis_Logo,
  "Terzo": Terzo_logo,
  "Ariba Prod": SAPAriba,
  "Ariba Test": SAPAriba,
  "Ariba Training": SAPAriba,
  "CMA": CMA_Logo,
  "SBAcci": Sbacci_Logo,
  "Keelvar": Keelvar,
  "Woodmac": woodmac_Logo,
  "S&P Global": SP_Global_Logo,

};

const CustomButtons = ({ isModal, appList, disabled=false, appCountToShow=2, isContractingCard=false }) => {
  // Only include apps that are active in overview Kpi page and display true in home page
  let activeApps = [], firstTwo = [], remaining = [];
  if(isModal){
    firstTwo = appList && appList?.slice(0, appCountToShow);
    remaining = appList && appList?.slice(appCountToShow);
  }else{
    activeApps = appList && appList?.filter(app => app.isActive || app.display);
    firstTwo = activeApps && activeApps?.slice(0, appCountToShow);
    remaining = activeApps && activeApps?.slice(appCountToShow);
  }
  // const activeApps = appList && appList?.filter(app => app.isActive || app.display);
  // const firstTwo = appList && appList?.slice(0, 2);
  // const firstTwo = activeApps && activeApps?.slice(0, 2);
  // const remaining = activeApps && activeApps?.slice(2);
  // const remaining = appList && appList?.slice(2);

  if(appList && appList?.some(item => item.app === "Archlet") && isModal){
    remaining = []
  }
//  console.log("appList", appList)
//  console.log("activeApps", activeApps)
//  console.log("firstTwo", firstTwo)
//  console.log("remaining", remaining)
  const handleClick = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };
  /* istanbul ignore next */
  const dropdownMenu = (
    <Menu>
      {remaining?.map((item, index) => (
        <Menu.Item 
                    key={index} 
                    style={{
                        // fontSize: '0.75rem',
                        fontSize: '12px',
                        fontWeight: 700,
                        fontFamily: 'Inter',
                        lineHeight: '140%',
                        color: '#005cbc',
                        padding: '5px 9px',
                    }} 
                   onClick={() => handleClick(item.url)}
                   {...getAppLinkAttributes(`${item.app || item.label}`)}
        >
                    <Tooltip
                    className=""
                    direction="left"
                    // maxWidth="70px"
                    style={{}}
                    text={item.tooltipText}
                    >
                    {(item.app || item.label) && 
                     (logoMap[item.app] || logoMap[item.label]) && 
                      (
                      <img
                        // src={item.logo}
                        src={logoMap[item.app] || logoMap[item.label]}
                        alt="icon"
                        style={{ marginRight: '5px', height: '1.4rem' }}
                      />
                    )}
                  
                    
                        {/* <img src={item.logo} alt="img" style={{marginRight: '5px', height: '1rem'}}/> */}
                      {item.app|| item.label}
                  </Tooltip>
        </Menu.Item>
      ))}
    </Menu>
  );
  /* istanbul ignore next */
  return (
    <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                ...(isModal ? { marginRight: '3rem', position: 'relative', bottom: '0.1rem' } : {})
                }}>
      {/* Group first two buttons with no gap */}
      <div style={{ display: 'flex' }}>
        {firstTwo?.map((item, index) => (
           <Tooltip
           className=""
          //  direction={isModal ? "left" : "left"}
          direction= { appList?.length > 1 && !isModal ? "top-middle" :  isContractingCard == true ? "top-middle" : "left"}
          //  direction="left"
           // maxWidth="70px"
           style={{}}
           text={item.tooltipText}
           >
          <Button
            disabled={disabled}
            key={index}
            onClick={() => handleClick(item.url)}
            style={{ borderRadius: firstTwo.length == 1 && index === 0 ? '5px' : remaining.length > 0 && index === 1 ? '0px' : index === 0 ? '5px 0 0 5px' : '0 5px 5px 0', 
                      borderColor: '#99CCFF',
                    //  color: '#005cbc', 
                    //  fontSize: '12px',
                    //  padding: '10px'
                      position: 'relative', top: item.icon=="ondemand_video" ? '0.55rem' : 
                      item.app == "Resilinc" ? '0.2rem' : item.app == "Sustainability Action Center" ? '0.3rem' : 
                      (item.app == "AMESA Contract Analytics" && isModal ) ? '0.55rem' : '',
                      // top: item.app == "Resilinc" ? '0.2rem': ''
                      }}
            className="buttonGrpItems-text"
            {...getAppLinkAttributes(`${item.app || item.label}`)}
          >
            {(item.app || item.label) && (logoMap[item.app] || logoMap[item.label]) && (
                      <img
                        src={logoMap[item.app] || logoMap[item.label]}
                        alt="icon"
                        style={{
                          height: item.app === 'Resilinc' || item.label === 'Resilinc'
                          ? '1.8rem'
                          : '1.4rem'
                          // height: '1.4rem'
                        }}
                      />
            )}
            {
                      item.icon=="ondemand_video" ? (
                        <>
                          <Icon
                                                    alt="alt value"
                                                    icon={"ondemand_video"}
                                                    size="small"
                                                    // style={{ color: '#fff' }}
                                                />
                        </>
                      ): <></>
            }
            {/* <img src={item.logo} alt="img" /> */}
            <span style={{ marginLeft: '-6px'}}>
            {item.app || item.label}
            </span>
            
          </Button>
         </Tooltip>
        ))}
      </div>

      {/* Add some spacing before dropdown */}
      {remaining?.length > 0 && (
        <div 
        className={disabled ? 'kpiOverviewcustomButtonsDisabled' : 'kpiOverviewcustomButtonsEnabled'}
        >
          <Dropdown 
            overlay={dropdownMenu} 
            trigger={['click']}
            placement="bottomRight"
            getPopupContainer={trigger => trigger.parentNode}
            disabled={disabled}
            className={disabled ? 'kpiOverviewcustomButtonsDisabled' : ''}
            >
            <Button style={{padding: '9px', color: '#005cbc', borderRadius: '0 5px 5px 0', borderColor: '#99CCFF',
                           ...(isModal ? {marginBottom:"14px", top: '1px'} : {})
                          }}
                    className={disabled ? 'kpiOverviewcustomButtonsDisabled' : ''}
              >
               {/* <DownOutlined /> */}
               <Icon
                                                alt="alt value"
                                                icon="keyboard_arrow_down"
                                                size="small"
                                                // style={{ color: '#fff' }}
                                            />
            </Button>
          </Dropdown>
        </div>
      )}
    </div>
  );
};

export default CustomButtons;
